import service from '~api/base';
import * as types from '../types';

export default {
  getHomeCustom({ commit }, payload) {
    return service.apiGetHomeCustom(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_CUSTOM_TOTAL, res.data);
      }
    });
  },
  getHomeBusi({ commit }, payload) {
    return service.apiGetHomeBusi(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_BUSI, res.data);
      }
    });
  },
  getHomeContract({ commit }, payload) {
    return service.apiGetHomeContract(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_CONTRACT, res.data);
      }
    });
  },
  getHomeCustomVisit({ commit }, payload) {
    return service.apiGetHomeCustomVisit(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_CUSTOM_VISIT, res.data);
      }
    });
  },
  getHomeProject({ commit }, payload) {
    return service.apiGetHomeProject(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_PROJECT, res.data);
      }
    });
  },
  getHomeMedicalCustomer({ commit }, payload) {
    return service.apiGetHomeMedicalCustomer(payload).then((res) => {
      console.log(res, 'res');
      if (res.data) {
        commit(types.GET_HOME_MEDICAL_CUSTOMER, res.data);
      }
    });
  },
  getHomeChartData({ commit }, payload) {
    return service.apiGetHomeChartData(payload).then((res) => {
      if (res.data) {
        commit(types.GET_HOME_CHART_DATA, res.data.data);
      }
    });
  },
};
